import * as React from "react";

export const BackIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        fill="none"
        viewBox="0 0 22 22"
        {...props}
    >
        <g clipPath="url(#a)">
            <path
                fill="url(#b)"
                d="M13.24 6.47 7.2 10.84a.196.196 0 0 0 0 .318l6.04 4.37c.13.093.313 0 .313-.16v-1.151c0-.25-.12-.489-.325-.636l-3.57-2.58 3.57-2.584a.78.78 0 0 0 .325-.635V6.63a.197.197 0 0 0-.312-.16"
            ></path>
            <path
                fill="url(#c)"
                d="M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11S17.075 0 11 0m0 20.134A9.135 9.135 0 0 1 1.866 11 9.136 9.136 0 0 1 11 1.866 9.135 9.135 0 0 1 20.134 11 9.135 9.135 0 0 1 11 20.134"
            ></path>
        </g>
        <defs>
            <linearGradient
                id="b"
                x1="11"
                x2="11"
                y1="0"
                y2="22"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F88A0C"></stop>
                <stop offset="1" stopColor="#FF4D21"></stop>
            </linearGradient>
            <linearGradient
                id="c"
                x1="11"
                x2="11"
                y1="0"
                y2="22"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#F88A0C"></stop>
                <stop offset="1" stopColor="#FF4D21"></stop>
            </linearGradient>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h22v22H0z"></path>
            </clipPath>
        </defs>
    </svg>
);
